module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Chapter01"
    }
  }, [_vm._v("I. A GENTLEMAN OF THE RANGE.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Chapter02"
    }
  }, [_vm._v("II. A SECRET KEPT.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter03"
    }
  }, [_vm._v("III. SISTER AND BROTHER.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. A RIDE FROM SUNRISE TO SUNSET.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. THE ROUND UP.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. A GIFT AND A PURCHASE.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. HER MAJESTY’S RANCHO.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. EL CAPITAN.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. THE NEW FOREMAN.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. DON CARLOS’S VAQUEROS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. A BAND OF GUERRILLAS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. FRIENDS FROM THE EAST.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. COWBOY GOLF.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. BANDITS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. THE MOUNTAIN TRAIL.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. THE CRAGS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. THE LOST MINE OF THE PADRES.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. BONITA.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. DON CARLOS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX. THE SHERIFF OF EL CAJON.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI. UNBRIDLED.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII. THE SECRET TOLD.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII. THE LIGHT OF THE WESTERN STARS.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV. THE RIDE. “STILLWELL!”.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV. AT THE END OF THE ROAD.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0